var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconClock = function SvgIconClock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 29 29",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9286",
    "data-name": "Grupo 9286",
    transform: "translate(-261.5 -329.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_444",
    "data-name": "Elipse 444",
    transform: "translate(264 332)",
    fill: "none",
    stroke: "#191750",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 13.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9267",
    "data-name": "Grupo 9267",
    transform: "translate(276 337.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6050",
    "data-name": "Caminho 6050",
    d: "M784,8079.637v-7.5",
    transform: "translate(-784.001 -8072.137)",
    fill: "none",
    stroke: "#191750",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6051",
    "data-name": "Caminho 6051",
    d: "M0,6V0",
    transform: "translate(6 7.5) rotate(90)",
    fill: "none",
    stroke: "#191750",
    strokeLinecap: "round",
    strokeWidth: 2.5
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconClock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_clock.80458a02.svg";
export { ForwardRef as ReactComponent };